// The two predicates that say what a citation IS, moved here by ruling 61 so
// the answer surface can bind them from inside the package. Every value they
// test is a `SimpleCitation.source_type` member already declared in
// `./answers`, and neither has a dependency of any kind.
//
// Extracted from src/components/chat/types/types.ts — history:
// git log --follow src/components/chat/types/types.ts

/**
 * Check if citation is file-based (attachment, user_document, or image).
 * All share similar display behavior (no URL, show file name, not clickable).
 */
export function isFileCitation(sourceType?: string): boolean {
  return (
    sourceType === 'attachment' ||
    sourceType === 'user_document' ||
    sourceType === 'image'
  );
}

/**
 * Check if citation/source is from an integration partner (EVI-678).
 * Partner citations have custom branding (logo, border color) and may have
 * partner-specific item IDs for deep linking.
 *
 * Usage:
 * - For SimpleCitation: isPartnerCitation(citation.source_type)
 * - For Source: isPartnerCitation(source.type)
 */
export function isPartnerCitation(sourceType?: string): boolean {
  return sourceType === 'integration_partner';
}
